import api from "./api";
var queryString = (params) => {
  return Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
};
export const getTransactions = (params) => {
  return api.get("/v1/cp/transactions?" + queryString(params));
};

export const postDepost = (params) => {
  return api.post("/v1/cp/transactions/deposit", params);
};

export const getCardDetails = (customerId) => {
  return api.post("/v1/cp/transactions/card-details", { customerId });
};

export const sendGodoPaySupportRequest = () => {
  return api.post("/v1/cp/transactions/godo-pay-support-request", {});
};

export const confirmOtp = (params) => {
  // console.log('Payment details ',params);
  return api.post("/v1/cp/transactions/confirm-otp", params);
};

export const createProfile = (params) => {
  return api.post("/v1/cp/transactions/create-profile", params);
};

export const getTransaction = (params) => {
  return api.post("/v1/cp/transactions/getTransaction", params);
};

export const postWithdrawal = (params) => {
  return api.post("/v1/cp/transactions/withdrawal", params);
};

export const requestWithdrawal = (params) => {
  return api.post("/v1/cp/transactions/request-withdrawal", params);
};

export const confirmWithdrawal = (params) => {
  return api.post("/v1/cp/transactions/confirm-withdrawal", params);
};

export const postInternaTransfer = (params) => {
  return api.post("/v1/cp/transactions/internal-transfer-otp", params);
};

export const createPayOrder = (params) => {
  return api.post("/v1/cp/transactions/pay", params);
};

export const checkoutId = (params) => {
  return api.post("/v1/cp/transactions/checkout", params);
};

export const getPMRates = () => {
  return api.get("/v1/cp/transactions/perfectmoney/rates");
};

export const cryptoData = (params) => {
  return api.post("v1/cp/transactions/crypto", params);
}
